import {useTranslation} from "react-i18next";
import React from 'react'
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {DownloadExcelIcon} from "@ui/icons/icons";
import {addLoadingBody, removeLoadingBody} from "@helpers/loadingHandler";
import {IExportDataSetAdditionalItem} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {
    GenerateExportExcelHeadColumnStylesCb,
    GenerateExportExcelRowStylesCb,
    HeadColumns
} from "@ui/tableCustom/types/table";

import {generateExcelFile} from "./helpers/helpers";
import {IExcelBaseSettings} from "@containers/export/containers/excel/types";


interface IProps<T> {
    fileName?: string,
    onDownload?: () => void,
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,

    columnExport: IColumnItem<T>[],
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    exportDataFromAllPage?: boolean,
    data: T[],
    additionalDataSet: IExportDataSetAdditionalItem<T>[],
    ignoredExportColumnKey?: string | null,
    order: keyof T | false,
    direction: string,
    allData?: T[],
    rootDataSetPosition?: number
    exportFromAllColumns?: boolean,
    rootYSteps?: number,
    baseSettings?: IExcelBaseSettings
}

function ExportExcel<T>({
                            fileName,
                            onDownload,
                            generateExportExcelRowStylesCb,
                            generateExportExcelHeadColumnStylesCb,

                            columnExport,
                            fullColumns,
                            headColumns,
                            exportDataFromAllPage,
                            allData,
                            data,
                            additionalDataSet,
                            order,
                            direction,
                            ignoredExportColumnKey,
                            rootDataSetPosition,
                            exportFromAllColumns,
                            baseSettings,
                            rootYSteps,
                        }: IProps<T>) {
    const {t} = useTranslation()

    const onGenerateExcel = async () => {
        const currentLengthData = allData && exportDataFromAllPage ? allData.length : data.length;
        if (currentLengthData < 250) {
            await generateExcelFile({
                fileName,
                onDownload,
                generateExportExcelRowStylesCb,
                generateExportExcelHeadColumnStylesCb,
                columnExport,
                fullColumns,
                headColumns,
                exportDataFromAllPage,
                allData,
                data,
                additionalDataSet,
                order,
                direction,
                t,
                ignoredExportColumnKey,
                rootDataSetPosition,
                exportFromAllColumns,
                baseSettings,
                rootYSteps
            })
            return
        }
        addLoadingBody({label: t('base.waitGenerateExcel')})
        setTimeout(async () => {
            await generateExcelFile({
                fileName,
                onDownload,
                generateExportExcelRowStylesCb,
                generateExportExcelHeadColumnStylesCb,
                columnExport,
                fullColumns,
                headColumns,
                exportDataFromAllPage,
                allData,
                data,
                additionalDataSet,
                order,
                direction,
                t,
                ignoredExportColumnKey,
                exportFromAllColumns,
                baseSettings,
                rootYSteps
            })
            removeLoadingBody()
        }, 100)
    }

    return (
        <IconButtonCustom
            tooltip={t('exportExcel')}
            onClick={onGenerateExcel}
            variant={'empty'}
        >
            <DownloadExcelIcon/>
        </IconButtonCustom>
    )
};

export default ExportExcel;
